import taxGif from "../../../assets/icons/tax.gif";
import { products } from "../../../constants/products";
import { UpsellCardBase } from "../../../components/UpsellCardBase";

const SpousalSupportUpsellCard: React.FC = () => {
  const key = "spousal_support_tracker";
  const product = products[key];
  if (!product) return null;

  return (
    <UpsellCardBase
      productKey={key}
      title="Spousal Support"
      description="Manage spousal support without the stress. Track payments, monitor agreements, and keep organized records. Whether you’re paying or receiving support, our tools help ensure transparency and accountability."
      imageSrc={taxGif}
      price={product.price}
    />
  );
};

export default SpousalSupportUpsellCard;
